import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { getSelectedSizeCodes, getSelectedWarehouse } from '../../model/selectors';
import { changePricesModalActions } from '../../model/slice/changePricesModalSlice';
import { getSelectedSizesLabel } from '../helpers/getSelectedSizesLabel';

export const useWatchStep = (): void => {
  const dispatch = useAppDispatch();

  const selectedWarehouse = useAppSelector(getSelectedWarehouse);
  const selectedSizeCodes = useAppSelector(getSelectedSizeCodes);

  useEffect(() => {
    if (selectedWarehouse) {
      dispatch(changePricesModalActions.changeStepData({ targetStepIndex: 0, stepData: selectedWarehouse.name }));
    }

    if (selectedSizeCodes.length) {
      dispatch(
        changePricesModalActions.changeStepData({
          targetStepIndex: 1,
          stepData: getSelectedSizesLabel(selectedSizeCodes),
        }),
      );
    }
  }, [dispatch, selectedSizeCodes, selectedWarehouse]);
};
